
import Page from "../shared/ui/components/Page";

import TemplateList from "../widgets/TemplateList";


export default function Template() {



  return (
    <Page title="Templates"  content={<TemplateList />} />
  );
}
